import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { Box, Flex, Collapse, Text, Divider, Image, useToast } from "@chakra-ui/react";
import { useHistory } from 'react-router-dom';
import PageLoader from '../../../global/components/helper-components/components/PageLoader';
import { getZoomOauthTokens } from '../../../organizations/actions/external-integration-actions';
import Auth from '../../../../config/app-specific-config/auth';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import { manage3pIntegrationSignup } from '../../../auth/actions/auth-integrations-actions';
import { capitalizeFirstLetter, getThisUserIdToken, redirectToNewPage, triggerLaunchdeckToast, validateEmail } from '../../../global/helpers/global-helpers';
import PublicPageLayout from '../../../layout/components/layout/components/PublicPageLayout';
import { LuUnlink } from "react-icons/lu";
import SquareTileIcon from '../../styles/images/launchdeck-square-tile-icon.jpg';
import { CgArrowsExchange } from "react-icons/cg";
import { SiZoom } from 'react-icons/si';
import appConfig from '../../../../config/app-config';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';
import PublicPageContentContainer from '../../../layout/components/layout/components/PublicPageContentContainer';
import useFeNotificationSender from '../../../global/hooks/send-fe-slack-notification';

function OauthCallbackPage(props) {

  const {
    // Actions
    getZoomOauthTokens,
    manage3pIntegrationSignup,
    // Redux state
    isMobileView,
    manage3pIntegrationSignupOutcome,
    getZoomOauthOutcome
  } = props || {};

  const oauthProvider = props ? props.match.params.oauthProvider : "";

  const initRef = useRef(false);
  const zoomAuthCodeRef = useRef(null);
  const history = useHistory();
  const toast = useToast();
  const {sendFeErrorNotification} = useFeNotificationSender();

  const [currentEvent, setCurrentEvent] = useState("")
  const [localErrorState, setLocalErrorState] = useState("")

  const [showLoadingState, setShowLoadingState] = useState(true)
  const [showProcessingState, setShowProcessingState] = useState(false)

  const [showEmailInput, setShowEmailInput] = useState(false)
  const [lockEmailInput, setLockEmailInput] = useState(false)

  const [showPasswordInput, setShowPasswordInput] = useState(false)
  const [showConfirmPasswordInput, setShowConfirmPasswordInput] = useState(false)

  const [emailInput, setEmailInput] = useState("")
  const [passwordInput, setPasswordInput] = useState("")
  const [confirmPasswordInput, setConfirmPasswordInput] = useState("")

  // UX: Error handling
  const [isInvalidEmail, setIsInvalidEmail] = useState(false)
  const [passwordError, setPasswordError] = useState(false)
  const [wrongPasswordError, setWrongPasswordError] = useState(false)
  const [wrongConfirmPasswordError, setWrongConfirmPasswordError] = useState(false)

  const handleChange = (event) => {
    const field = event.target.name;
    const value = event.target.value;

    switch (field) {
      case ("email"): {
        setIsInvalidEmail(false)
        setEmailInput(value)
        break;
      }
      case ("password"): {
        setPasswordInput(value)
        passwordError && setPasswordError(false)
        wrongPasswordError && setWrongPasswordError(false)
        break;
      }
      case ("confirm-password"): {
        setConfirmPasswordInput(value)
        wrongConfirmPasswordError && setWrongConfirmPasswordError(false)
        break;
      }
      default: {
        break;
      }
    }
  }

  const handleSubmitForm = (useCase) => {

    switch (useCase) {
      case ("check-if-existing-user"): {
        const isValidEmail = validateEmail(emailInput);

        if (!isValidEmail) {
          setIsInvalidEmail(true)
        } else {
          setShowProcessingState(true)
          manage3pIntegrationSignup({
            event: useCase,
            emailInput: emailInput.trim()
          })
        }
        break;
      }
      case ("login-existing-3p-integration-user"): {
        if (passwordInput) {
          if (passwordInput.length < 6) {
            setPasswordError(true)
          } else {
            setShowProcessingState(true)
            manage3pIntegrationSignup({
              event: useCase,
              emailInput: emailInput.trim(),
              passwordInput: passwordInput
            })
          }
        } else {
          setPasswordError(true)
        }
        break;
      }
      case ("create-3p-integration-user-account"): {
        if (passwordInput && confirmPasswordInput) {
          if (passwordInput.length < 6) {
            setPasswordError(true)
          } else if (passwordInput !== confirmPasswordInput) {
            setWrongConfirmPasswordError(true)
          } else {
            setShowProcessingState(true)
            manage3pIntegrationSignup({
              event: useCase,
              emailInput: emailInput.trim(),
              passwordInput: passwordInput,
              referralSource: oauthProvider
            })
          }
        } else {
          setPasswordError(true)
        }
        break;
      }
      default: {
        break;
      }
    }
  }


  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const authorizationCode = queryParams.get('code'); // Extract the authorization code
    zoomAuthCodeRef.current = authorizationCode;

    // If logged in
    if (Auth.isLoggedIn() !== null) {
      if (zoomAuthCodeRef.current && !initRef.current) {
        // Send the authorization code to your backend to exchange for tokens
        getZoomOauthTokens({ authorizationCode: zoomAuthCodeRef.current, userIdToken: getThisUserIdToken() })
        initRef.current = true;

      } else {
        // TODO: Graceful handling of case where the authorization code is not present
        sendFeErrorNotification({
          errorCode: "ZXU355", 
          errorMessage: "Authorization code not found in Oauth callback page while integrating from Zoom", 
          errorReportMetadata: {
            userIdToken: "",
            orgId: "",
            internalNotes: "",
            errorReportMetadata: {}
          }
        })

        history.push(`/page-not-found`, {})
      }
    } else {
      // If not logged in...
      setShowEmailInput(true)
      setShowLoadingState(false)
      setShowProcessingState(false)
      // Scenario B: Show password + confirmation to create a new 

    }
  }, [history, getZoomOauthTokens])

  useEffect(() => {
    if (manage3pIntegrationSignupOutcome) {
      const { eventProcessed, nextEvent, errorMessage } = manage3pIntegrationSignupOutcome || {};

      setCurrentEvent(nextEvent)

      switch (eventProcessed) {
        case ("check-if-existing-user"): {
          if (nextEvent === "seek-login-password") {
            setShowPasswordInput(true)
            setLockEmailInput(true)
          } else if (nextEvent === "continue-signup-account") {
            setShowPasswordInput(true)
            setShowConfirmPasswordInput(true)
            setLockEmailInput(true)
          } else if (nextEvent === "show-invalid-email-error") {
            setLocalErrorState({
              errorMessage: errorMessage,
              ctaRedirectRoute: appConfig.landingPage
            })
          } else {
            toast(
              triggerLaunchdeckToast({
                useCase: "show-error-state",
                label: "Unfortunately something went wrong on our end. Please try again later.",
                isMobileView
              })
            )
          }

          break;
        }
        case ("login-existing-3p-integration-user"): {
          if (nextEvent === "show-unsuccessful-login") {
            setWrongPasswordError(true)
          } else if (nextEvent === "login-existing-user") {
            getZoomOauthTokens({ authorizationCode: zoomAuthCodeRef.current, userIdToken: getThisUserIdToken() })
            initRef.current = true;
          }
          break;
        }
        case ("create-3p-integration-user-account"): {
          if (nextEvent === "show-unsuccessful-create-user-outcome") {

            setLocalErrorState({
              errorMessage: errorMessage,
              ctaRedirectRoute: appConfig.landingPage
            })

          } else if (nextEvent === "login-created-user") {
            const userIdToken = getThisUserIdToken()
            userIdToken && getZoomOauthTokens({ authorizationCode: zoomAuthCodeRef.current, userIdToken: userIdToken, syncUserData: true, isCreatedUser: true })

            initRef.current = true;
          }

          break;
        }
        default: {
          break;
        }
      }


      setShowProcessingState(false)
    }
  }, [manage3pIntegrationSignupOutcome, getZoomOauthTokens]);

  useEffect(() => {
    if (getZoomOauthOutcome) {
      const { unableToGetZoomTokens, errorMessage, ctaRedirectRoute } = getZoomOauthOutcome || {};

      if (!!unableToGetZoomTokens) {
        setLocalErrorState({
          errorMessage,
          ctaRedirectRoute
        })
      }
      setShowProcessingState(false)
    }
  }, [getZoomOauthOutcome]);

  const renderContent = () => {
    if (!!showLoadingState) {
      return (
        <Box>
          <PageLoader />
        </Box>
      )
    } else {

      if (showEmailInput) {
        return (
          <Flex w='100%' direction='column' maxW='20em' py='2em'>
            <Flex gap={4} justify='center' align='center' mb='2em'>
              {/* Show logos */}

              <Box as={SiZoom} boxSize="3.5em" color="brandDark.500" border='1px solid' borderColor='gray.200' rounded='0.5em' p='0.5em' />
              <Box as={CgArrowsExchange} boxSize='1.25em' color="gray.400" />
              <Image src={SquareTileIcon} boxSize='3.5em' border='1px solid' borderColor='gray.200' rounded='0.5em' />
            </Flex>
            <Flex w='100%' justify='center' fontWeight='600' fontSize='1.2em'>
              Welcome to Launchdeck
            </Flex>

            <Flex w='100%' justify='center' fontSize='0.8em' mb='3.5em'>
              Pair your Zoom account with Launchdeck
            </Flex>

            <Box w='100%'>
              <LaunchdeckFormInput
                label='Email'
                name={'email'}
                onChange={handleChange}
                value={emailInput}
                placeholder={''}
                isRequired={true}
                isDisabled={lockEmailInput || showProcessingState}
                autoFocus={true}

                errorLogic={isInvalidEmail}
                errorMessage={'Please use a valid email format'}
              />

              {!showPasswordInput &&
                <Flex w='100%' mt='1.5em'>
                  <LaunchdeckButton bg='brand.500' color='white' px='1em' w='100%' loadingLogic={showProcessingState} onClick={() => handleSubmitForm('check-if-existing-user')} label='Continue' />
                </Flex>
              }
            </Box>

            <Collapse width='100%' in={showPasswordInput} animateOpacity>
              {showPasswordInput && <Flex direction='column' w='100%'>
                <Box mt='1.5em' mb='1em' w='100%'>
                  <Divider mb='1em' />
                  <LaunchdeckFormInput
                    label='Password'
                    name={'password'}
                    onChange={handleChange}
                    value={passwordInput}
                    type='password'
                    isDisabled={showProcessingState}
                    isRequired={true}

                    errorLogic={passwordError || wrongPasswordError}
                    errorMessage={`We are unable to validate with this password. \nIf you've forgotten your password, please reset & try again`}
                  />
                </Box>

                {currentEvent === "seek-login-password" &&
                  <>
                    <Flex fontSize='0.7em' justify='center' color='gray.500'>To continue, login with your Launchdeck account</Flex>
                    <Box my='0.875em' alignSelf={'center'} w='100%'>
                      <LaunchdeckButton bg='brand.500' color='white' px='1em' w='100%' loadingLogic={showProcessingState} onClick={() => handleSubmitForm('login-existing-3p-integration-user')} label={(passwordError || wrongPasswordError) ? 'Retry' : 'Continue'} />
                    </Box>
                  </>
                }

                {wrongPasswordError && currentEvent === "show-unsuccessful-login" &&
                  <>
                    <Box my='0.875em' alignSelf={'center'} w='100%'>
                      <LaunchdeckButton bg='brand.500' color='white' px='1em' w='100%' loadingLogic={showProcessingState} onClick={() => handleSubmitForm('login-existing-3p-integration-user')} label={(passwordError || wrongPasswordError) ? 'Retry' : 'Continue'} />
                    </Box>
                  </>
                }


              </Flex>}
            </Collapse>

            <Collapse width='100%' in={showConfirmPasswordInput} animateOpacity>
              {showConfirmPasswordInput && <Flex direction='column' w='100%'>
                <Box mb='1em' w='100%'>
                  <LaunchdeckFormInput
                    label='Confirm password'
                    name={'confirm-password'}
                    onChange={handleChange}
                    value={confirmPasswordInput}
                    type='password'
                    isDisabled={showProcessingState}
                    isRequired={true}

                    errorLogic={wrongConfirmPasswordError}
                    errorMessage={`Your confirmation password does not match - please try again`}
                  />

                </Box>
                <>
                  <Text my='0.875em' fontSize='0.7em' justify='center' color='gray.500' whiteSpace='break-spaces' textAlign='center'>{`It seems you don't have a Launchdeck account to link ${capitalizeFirstLetter(oauthProvider)} with yet.`}</Text>
                  {/* <Flex my='0.875em' fontSize='0.7em' justify='center' color='gray.500'>It seems you don't have a Launchdeck account to link {oauthProvider} with yet. Set a password & integrate</Flex> */}
                  <LaunchdeckButton bg='brand.500' color='white' px='1em' loadingLogic={showProcessingState} onClick={() => handleSubmitForm('create-3p-integration-user-account')} label='Create account & integrate' />
                </>
              </Flex>}
            </Collapse>

          </Flex>
        )
      } else return null

    }

  }

  const renderErrorManagement = () => {
    if (localErrorState) {
      const { errorMessage, ctaRedirectRoute } = localErrorState || {};

      return (
        <Flex direction='column' w='20em' justify='center' align='center' gap={4}>
          <Box as={LuUnlink} boxSize='4em' color='brandPink.500' />
          <Text my='0.875em' fontSize='0.7em' justify='center' color='gray.500' whiteSpace='break-spaces' textAlign='center'>{errorMessage}</Text>
          <LaunchdeckButton bg='brand.500' color='white' px='1em' onClick={() => redirectToNewPage(ctaRedirectRoute)} label='Continue' />
        </Flex>
      )
    }
  }


  return (
    <PublicPageLayout>
      <PublicPageContentContainer>
        <Flex minW='28em' maxW='80%' direction='column' justify='center' align='center' p='1.5em' bg='white' border='1px solid' borderColor='gray.300' rounded='0.25em'>
          {localErrorState ? renderErrorManagement() : renderContent()}
        </Flex>
      </PublicPageContentContainer>
    </PublicPageLayout>
  )
}



function mapStateToProps(state) {
  return {
    manage3pIntegrationSignupOutcome: state.manage3pIntegrationSignupOutcome.results,
    getZoomOauthOutcome: state.getZoomOauthOutcome.results.data,
    isMobileView: state.mobileViewMode.isMobileView
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getZoomOauthTokens,
      manage3pIntegrationSignup
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OauthCallbackPage));